// eslint-disable-next-line import/no-cycle
import request from '@/plugins/axios';

/**
 * @description 获取用户信息
 * @returns
 */
export const getUserInfo = () => request({
  method: 'get',
  url: '/api/content/personal/center'
});

/**
 * @description 获取用户权限
 * @returns
 */
export const getUserPermission = () => request({
  method: 'get',
  url: '/api/content/personal/entry_v3_5'
});

/**
 * @description 获取用户的会员信息
 * @returns
 */
export const getVipInfo = () => request({
  method: 'get',
  url: '/api/user/vip_info'
});

/**
 * @description 获取用户收藏、购买的课程数量，卡劵数量，奖学金
 * @returns
 */
export const getUserOtherInfo = () => request({
  method: 'get',
  url: '/api/user/wkuser_center_info'
});

/**
 * @description 获取用户的积分信息
 * @returns
 */
export const getUserPointInfo = () => request({
  method: 'get',
  url: '/api/user_point/mine_v1'
});

/**
 * @description 获取广告信息
 * @param {number} [ad_type=106] 广告类型，106个人中心广告
 * @returns
 */
export const getAdInfo = (ad_type = 106) => request({
  method: 'get',
  url: '/api/web_ad/get_ad',
  params: {
    ad_type
  }
});

/**
 * @description 获取用户学习天数和排名
 * @returns {Promise}
 */
export const getUserStudyDays = () => request({
  method: 'get',
  url: '/api/lesson/user_rank'
});
